module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-stone-path.c84368c5.png";